import React from "react";
import {ValidationState} from "../util/ValidationState";
import {FormControl} from "./FormControl";
import "./HereMapsAPIPrompt.css";
import {ValidatingTextInput} from "./ValidatingTextInput";

interface Props {
  value: string | null;
  onChange: (val: string | null) => void;
  validationState: ValidationState;
  validationFeedback: string | null;
}

export const HereMapsAPIKeyPrompt = ({value, onChange, validationState, validationFeedback}: Props) => {
  const handleChange = (val: string) => {
    onChange(val ? val : null);
  }

  return (
      <div className="here-maps-api-key-prompt">
        <FormControl>
          <label>API key</label>
          <ValidatingTextInput
              value={value || ""}
              onChange={handleChange}
              validationState={validationState}
              validationFeedback={validationFeedback}
          />
        </FormControl>

      </div>
  )
}